import React from 'react'

const Footer = () => {
     return (<>
          <div className='w-screen bg-gray-800 p-20 mt-96'>
               <h1 className='text-center text-white text-5xl'> All right reserved &copy; Copyright 2024</h1>
          </div>
     </>
     )
}
export default Footer